<template>
  <div class="panel">
    <div class="panel-heading">
      <h1 class="panel-title">云盘</h1>
    </div>
    <div class="panel-body">
      <div class="mychilidTab-box clearfix">
        <ul class="nav nav-tabs child-tabs" id="mychlidTab">
          <li
            v-for="list in tabs"
            :key="list.id"
            :class="{active: list.href === tab}"
            @click="switchTabByClick(list)"
          >
            <a :href="'#'+list.href" data-toggle="tab">{{list.name}}</a>
          </li>
        </ul>
      </div>
      <div class="filepath" v-show="'persona-sharefile' === tab">
        <a :class="{'no-click':noClick}" v-show="'persona-file' === tab">返回上一级</a>
        <a
          @click="getShareResourceList('up')"
          :class="{'no-click':noClick}"
          v-show="'persona-sharefile' === tab"
        >返回上一级</a>
        <span class="line">|</span>
        <a @click="getAllInfo">{{bread}}</a>
        <span v-for="lel in level" :key="lel.number" v-show="'persona-file' === tab">
          <i class="ti-angle-right"></i>
          <a>{{lel.name}}</a>
        </span>
        <span v-for="(lel,index) in level" :key="lel.index" v-show="'persona-sharefile' === tab">
          <span class="line">></span>
          <a @click="getShareResourceList(lel)">{{index === 0 ? lel.share_title : lel.name}}</a>
        </span>
      </div>
      <keep-alive>
        <component :is="table" :isList="isList" @getShareResourceList="getShareResourceList"></component>
      </keep-alive>
      <div class="drive-more clearfix">
        <span class="pull-right">
          <router-link :to="{name:'recdrive'}" class="more-rec">
            云盘中的更多内容
            <i class="ti ti-angle-right"></i>
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CloudDisk",
  components: {
    Table: () => import("@/components/Table/Table"),
    TableShareResource: () => import("@/components/Table/TableShareResource")
  },
  data() {
    return {
      bread: "全部",
      level: [],
      isList: true,
      searchTab: {
        "persona-file": 0,
        "persona-sharefile": 1
      },
      tabs: [
        {
          id: 1,
          table: "Table",
          name: "文件",
          bread: "全部",
          href: "persona-file",
          isShowUpload: true,
          isShowList: true,
          isShowTag: true,
          query: {
            disk_type: "cloud",
            category: "all",
            is_star: false,
            is_rec: false,
            number: 0
          }
        },
        {
          id: 4,
          table: "Table",
          name: "已分享",
          bread: "全部",
          href: "persona-sharefile",
          isShowUpload: false,
          isShowList: true,
          isShowTag: false,
          query: {
            share_type: "user|group|link"
          }
        }
      ]
    };
  },
  created() {
    this.jumpToPersondrive();
    //使用之前选择的drive和tab状态
    this.switchTab(this.tabs[this.searchTab[this.tab]]);
  },
  computed: {
    noClick() {
      return this.level.length ? false : true;
    },
    table() {
      let tab = this.tabs.find(tab => tab.href === this.tab);
      return tab.table;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    datas() {
      return this.$store.state.drive.datas;
    },
    listQuery() {
      return this.$store.state.drive.listQuery;
    }
  },
  methods: {
    jumpToPersondrive() {
      this.$store.commit("SWITCH_DRIVE", {
        drive: "persona",
        group: null,
        tab: "persona-file"
      });
    },
    /**
     * 点击跳转tab
     * 规则：点击当前所在的tab不用
     **/
    switchTabByClick(tab) {
      if (tab.href != this.tab) {
        this.switchTab(tab);
      }
    },
    switchTab(tab) {
      this.bread = tab.bread;
      this.level = [];
      tab.table = "Table";
      this.$store.commit("SWITCH_TAB", tab.href);
      this.getInfo();
    },
    getInfo() {
      this.$store.dispatch("getInfo");
    },
    getShareResourceList(data) {
      let index;
      if (this.level.length > 1) {
        index = this.level.indexOf(data);
      } else {
        let res = this.level.find(item => {
          return (
            item.share_number === data.share_number ||
            item.number === data.number
          );
        });
        index = this.level.indexOf(res);
      }
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      let tab = this.tabs.find(item => item.href === this.tab);
      if (this.level.length === 0) {
        this.$store.commit("setDatas", []);
        tab.table = "Table";
        this.getInfo();
        return false;
      } else {
        this.$store.commit("setDatas", []);
        tab.table = "TableShareResource";
      }
      this.$store
        .dispatch("getShareResourceList", {
          share_creater_name: data.share_creater_name,
          share_number:
            this.level.length === 0
              ? data.share_number
              : this.level[0].share_number,
          share_resource_number:
            this.level.length < 2
              ? null
              : this.level[this.level.length - 1].number,
          is_rec: "false"
        })
        .then(res => {
          if (res.status_code === 200) {
            this.$store.commit("setLoading", false);
            this.$store.commit("GET_RESOURCE_INFO", res.entity);
            if (!res.entity.length) {
              this.$store.commit("setNothing", true);
            } else {
              this.$store.commit("sortByDefault", 3);
              this.$store.commit("sortByHeader");
            }
          } else if (res.status_code === 439) {
            this.$store.commit("setLoading", false);
            this.$store.commit("setShareExpired", true);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    },
    getAllInfo() {
      let tab = this.tabs.find(item => item.href === this.tab);
      tab.table = "Table";
      this.level = [];
      this.$store.commit("MODIFY_LIST_QUERY", {
        number: 0
        // offset: 0,
        // limit: 5
      });
      this.getInfo();
    }
  }
};
</script>

<style scoped>
.no-click {
  color: #ddd;
  cursor: default;
}
.more-rec {
  color: #006adf;
}
</style>